import request from "../utils/request";
import {
  WORKFLOW
} from "../utils/env"
const schemeApi = {
  SchemeList: 'news/tab',
  copyArtical: 'news/v2',
  apply_list: 'news/module/apply/category/id',
  apply_list_my: 'news/module/apply_list/all',
  APPLY_DETAIL: 'news/module/apply/record',
  APPLY_CANCEL: 'news/module/apply/cancel',
  APPLY_PROCESS: WORKFLOW + 'news/apply/process',
  APPLY_UPDATE: 'news/module/apply/update',
  APPLY_DELETE: 'news/module/apply/delete',
  apply_list_nom: 'news/apply/category/id',
  apply_list_my_nom: 'news/apply_list/all',
  APPLY_DETAIL_nom: 'news/apply/record',
  APPLY_CANCEL_nom: 'news/apply/cancel',

  APPLY_UPDATE_nom: 'news/apply/update',
  APPLY_DELETE_nom: 'news/apply/delete',

}


export function getTabs(params) {
  return request({
    url: schemeApi.SchemeList,
    method: "get",
    params: params,
  })
}

export function copyArtical(parameter) {
  return request({
    url: schemeApi.copyArtical,
    method: "post",
    data: parameter,
  })
}
export function apply_list(params) {
  return request({
    url: schemeApi.apply_list,
    method: "get",
    params: params,
  })
}

export function apply_list_my(params) {
  return request({
    url: schemeApi.apply_list_my,
    method: "get",
    params: params,
  })
}

export function APPLY_DETAIL(params) {
  return request({
    url: schemeApi.APPLY_DETAIL,
    method: "get",
    params: params,
  })
}


export function APPLY_CANCEL(parameter) {
  return request({
    url: schemeApi.APPLY_CANCEL,
    method: "post",
    data: parameter,
  })
}

export function APPLY_PROCESS(parameter) {
  return request({
    url: schemeApi.APPLY_PROCESS,
    method: "post",
    data: parameter,
  })
}

export function shndla(parameter) {
  return request({
    url: schemeApi.shndla,
    method: "post",
    data: parameter,
  })
}
export function APPLY_DELETE(parameter) {
  return request({
    url: schemeApi.APPLY_DELETE + '/?' + parameter,
    method: "delete",
  })
}

export function apply_list_nom(params) {
  return request({
    url: schemeApi.apply_list_nom,
    method: "get",
    params: params,
  })
}

export function apply_list_my_nom(params) {
  return request({
    url: schemeApi.apply_list_my_nom,
    method: "get",
    params: params,
  })
}

export function APPLY_DETAIL_nom(params) {
  return request({
    url: schemeApi.APPLY_DETAIL_nom,
    method: "get",
    params: params,
  })
}


export function APPLY_CANCEL_nom(parameter) {
  return request({
    url: schemeApi.APPLY_CANCEL_nom,
    method: "post",
    data: parameter,
  })
}


export function APPLY_DELETE_nom(parameter) {
  return request({
    url: schemeApi.APPLY_DELETE_nom + '/?' + parameter,
    method: "delete",
  })
}
